import {Component, OnInit} from '@angular/core';
import {PopupDialogBase} from '../../../component/popup-dialog-base';
import {MessageService} from '../../../component/message.service';
import {RequestExecutor} from '../../../util/request-executor';
import {Router} from '@angular/router';
import {User} from '../../../domain/user';

@Component({
  selector: 'app-assign',
  templateUrl: './assign-order-user.component.html',
  styleUrls: ['./assign-order-user.component.css'],
  standalone: false
})
export class AssignOrderUserComponent extends PopupDialogBase implements OnInit {
  users: User[] = [];
  orderIds: string[];

  progress = false;

  user: string = '';

  constructor(
    private request: RequestExecutor,
    private messageService: MessageService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.fetchUsers();
  }

  cancel() {
    this.close();
  }

  assign() {
    this.progress = true;

    this.request.post('/order/assign/user/batch', {OrderIds: this.orderIds, UserId: this.user})
      .then(() => {
        this.messageService.showBottomSuccessSnackBar('Turen' + (this.orderIds.length > 1 ? 'e' : '') + ' ble tildelt');

        this.close();
      })
      .catch(error => {
        if (error.status == 401) {
          this.router.navigate(['login']);
        } else {
          this.messageService.showBottomErrorSnackBar('Kunne ikke tildele turen' + (this.orderIds.length > 1 ? 'e' : ''));
        }
      })
      .finally(() => this.progress = false);
  }

  private fetchUsers() {
    this.progress = true;

    let parameters = {
      userType: 'Driver',
      excludeUsersWithoutPhoneNumber: true
    };

    this.request.get('/users', parameters)
      .then(r => this.users = r.Users)
      .catch(e => {})
      .finally(() => this.progress = false);
  }
}
